import { render } from "./TheNotifications.vue?vue&type=template&id=31a385a4&scoped=true"
import script from "./TheNotifications.vue?vue&type=script&lang=js"
export * from "./TheNotifications.vue?vue&type=script&lang=js"

import "./TheNotifications.vue?vue&type=style&index=0&id=31a385a4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a385a4"]])

export default __exports__